import { render } from "./FirewallForm.vue?vue&type=template&id=b35d7f34"
import script from "./FirewallForm.vue?vue&type=script&lang=js"
export * from "./FirewallForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lynkto-vlan-user-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__